import { Star, BadgeCheck } from "lucide-react";

const getMoonPhaseEmoji = () => {
  const now = new Date();
  const knownNewMoon = new Date('2024-01-11T08:57:00Z').getTime();
  const lunarCycle = 29.530588 * 24 * 60 * 60 * 1000;
  const diff = now.getTime() - knownNewMoon;
  const phase = (diff % lunarCycle) / lunarCycle;
  
  if (phase < 0.0625 || phase > 0.9375) return "🌑";
  if (phase < 0.1875) return "🌒";
  if (phase < 0.3125) return "🌓";
  if (phase < 0.4375) return "🌔";
  if (phase < 0.5625) return "🌕";
  if (phase < 0.6875) return "🌖";
  if (phase < 0.8125) return "🌗";
  return "🌘";
};

const SubscriberBadge = ({ className = "", planId = "estrela" }: { className?: string; planId?: string | null }) => {
  if (planId?.includes("lunar")) {
    return (
      <span className={`inline-flex items-center gap-0.5 text-blue-300 ${className}`} title="Assinante Lunar">
        <span className="text-[1.1em]">{getMoonPhaseEmoji()}</span>
      </span>
    );
  }
  
  if (planId?.includes("basic")) {
    return (
      <span className={`inline-flex items-center gap-0.5 text-slate-300 ${className}`} title="Assinante Básico">
        <BadgeCheck className="w-4 h-4 fill-slate-300 text-slate-800" />
      </span>
    );
  }

  // Estrela e outros VIPs
  return (
    <span className={`inline-flex items-center gap-0.5 text-yellow-400 ${className}`} title="Assinante Estrela">
      <Star className="w-4 h-4 fill-yellow-400 text-yellow-600" />
    </span>
  );
};

export default SubscriberBadge;
